export const REQUEST = "/api/users/users/-REQUEST#staff";
export const SUCCESS = "/api/users/users/-SUCCESS#staff";
export const FAILURE = "/api/users/users/-FAILURE#staff";


// WEBPACK FOOTER //
// ./src/ducks/staff/constants.js